/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { MediaList } from '../data/mediaModel';
import { ImagePathurl } from '../helper/constants';
import fetchAPI from '../helper/axios';
import { CMS_API_BASE ,IsDevMode,frontUrl} from '../helper/constants';
import { decryptId, generateSlug } from '../helper/encript';
import { Helmet } from 'react-helmet-async';
import { formatDate } from '../helper/dateFormat';

// Base URL for the API
 const API_BASE = CMS_API_BASE;
 const front_Url = frontUrl;
 function cleanAndParseJSONLD(raw: string) {
  if (!raw) return null;

  try {
    // 1️⃣ Remove HTML tags like <p>, <br>, etc.
    let text = raw.replace(/<\/?[^>]+(>|$)/g, "");

    // 2️⃣ Decode HTML entities (&nbsp;, &quot;, etc.)
    text = text
      .replace(/&nbsp;/g, " ")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");

    // 3️⃣ Replace fancy (curly) quotes with straight quotes
    text = text.replace(/[“”]/g, '"').replace(/[‘’]/g, "'");

    // 4️⃣ Trim whitespace
    text = text.trim();

    // 5️⃣ Parse JSON safely
    return JSON.parse(text);
  } catch (error) {
    console.error("Invalid JSON-LD schema:", error, raw);
    return null;
  }
}
const MediaDetail: React.FC = () => {
   
const { pathname } = useLocation();
        const PathUrl=ImagePathurl;
        const [Mediablock, setDataBlock] = useState<MediaList[]>([]);
          const [MediaImgmob1, setMediaImgData2] = useState<any>();
       // const [Mediadetail, setDatadetail] = useState<MediaList>();
          const [Mediadbannerdtl, setDatabdtl] = useState<any>();
           const [Mediadbimg, setDatabimg] = useState<any>();
  const [retry, setRetry] = useState(0); // for retry trigger
        const [loading, setLoading] = useState<boolean>(true);
        const [error, setError] = useState<string | null>(null);

const currentUrl = window.location.href;
 
    useEffect(() => {
         const loadData = async () => {
          try {
           
            setDatabdtl(await fetchAPI('node/56'));
            setDatabimg( await fetchAPI('media/99/edit')) ;
             setMediaImgData2(await fetchAPI('media/137/edit'));
          } catch (err: any) {
            setError(err.message);
             // Retry after 3 seconds
        setTimeout(() => setRetry((prev) => prev + 1), 3000);
          } finally {
            setLoading(false);
          }
        };
         const fetchJobs = async () => {
                try {
               // const response = await fetch('/api/jsonapi/node/media_block?sort=-created&include=field_featured_image.field_media_image,field_media_detail_image.field_media_image');

                 let response: Response;
                               if (IsDevMode === 1) {
                                 response = await fetch('/api/jsonapi/node/media_block?sort=-created&include=field_featured_image.field_media_image,field_media_detail_image.field_media_image');
                               } else {
                                 response = await fetch(API_BASE + '/jsonapi/node/media_block?sort=-created&include=field_featured_image.field_media_image,field_media_detail_image.field_media_image');
                               }
               
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
               // const data = await response.json();
                  const { data, included } = await response.json();
            
                    const getImageUrl = (mediaId: string) => {
                    // 1️⃣ Find media entity
                    const media = included?.find(
                        (item: any) =>
                        item.type === "media--image" && item.id === mediaId
                    );
            
                    // 2️⃣ Find linked file entity
                    const fileId = media?.relationships?.field_media_image?.data?.id;
                    const file = included?.find(
                        (item: any) => item.type === "file--file" && item.id === fileId
                    );
            
                    // 3️⃣ Return full URL
                    return file?.attributes?.uri?.url
                        ? `${file.attributes.uri.url}`
                        : null;
                    };
            
                    const formatted = data.map((item: any) => ({
                    id: item.id,
                    created: item.attributes.created,
                    field_media_title: item.attributes.field_media_title,
                    field_meta_title: item.attributes.field_meta_title ? item.attributes.field_meta_title : "",
                    field_meta_description: item.attributes.field_meta_description ? item.attributes.field_meta_description : "",
                    field_alt_tag: item.attributes.field_alt_tag ? item.attributes.field_alt_tag :"",
                      field_alt_tag_image_seo: item.attributes.field_alt_tag_image_seo ? item.attributes.field_alt_tag_image_seo :"",
                    field_article_schema: item.attributes.field_article_schema ? item.attributes.field_article_schema.value : "",
                    field_category_tag: item.attributes.field_category_tag,
                    field_seo_h1: item.attributes.field_seo_h1 ? item.attributes.field_seo_h1 : "",
                    field_content: item.attributes.field_content.value,
                     field_featured_url: getImageUrl(item.relationships.field_featured_image?.data?.id),
                    field_media_detail_url: getImageUrl(item.relationships.field_media_detail_image?.data?.id),
                    //  field_media_detail_url: getImageUrl(item.relationships.field_media_detail_image?.data?.id),
             
    
                 
                    }));
     
            setDataBlock(formatted);
               
                } catch (error) {
                console.error('Error fetching Data:', error);
                 // Retry after 3 seconds
        setTimeout(() => setRetry((prev) => prev + 1), 10000);
                }
            };
      fetchJobs();
     loadData();
    }, [retry]);

  // const { id } = useParams<{ id: string }>(); // ✅ explicitly type id
  // const numericId = decryptedId ? parseInt(decryptedId, 10) : null;
  // const numericId = id ? parseInt(id, 10) : null;
  const { id,category } = useParams<{ id: string,category:string }>();
  // const Mediadetail=Mediablock.find(item => String(item.field_media_title) === title);
  const Mediadetail=Mediablock.find(item => generateSlug(item.field_media_title) === id?.toLowerCase());


  if (!Mediadetail) {
    return <p>Media not found.</p>;
  }
const parsedSchema = cleanAndParseJSONLD(Mediadetail.field_article_schema || "");
  return (

   <>
    <Fragment>
         <head>
         {/* ✅ Primary Title */}
           {Mediadetail.field_meta_title && <title>{Mediadetail.field_meta_title}</title>}

           {Mediadetail.field_meta_title && <meta name="title" content={Mediadetail.field_meta_title} />}
   
           {/* ✅ Meta Description */}
           {Mediadetail.field_meta_description && <meta name="description" content={Mediadetail.field_meta_description} />}
   
           {/* ✅ Secondary Meta (Suggested Description) */}
           {Mediadetail.field_seo_h1 && <meta name="h1" content={Mediadetail.field_seo_h1} />}
          
        
           {/* ✅ Canonical URL */}
           {Mediadetail.field_media_title && <link rel="canonical" href={`${front_Url}resources/${Mediadetail.field_category_tag}/${generateSlug((Mediadetail.field_media_title))}`} />}
           {/* ✅ meta img tag */}
            {/* <img src={`${PathUrl}${Mediadetail.field_media_detail_url}`} alt={Mediadetail.field_alt_tag}/> */}
           {/* ✅ Open Graph */}
           {Mediadetail.field_meta_title && <meta property="og:title" content={Mediadetail.field_meta_title} />}
           {Mediadetail.field_meta_description && (
             <meta property="og:description" content={Mediadetail.field_meta_description} />
           )}
           {Mediadetail.field_media_title && <meta property="og:url" content={`${front_Url}resources/${Mediadetail.field_category_tag}/${generateSlug((Mediadetail.field_media_title))}`} />}
           <meta property="og:type" content="website" />
   
           {/* ✅ Twitter Meta */}
           <meta name="twitter:card" content="summary_large_image" />
           {Mediadetail.field_meta_title && <meta name="twitter:title" content={Mediadetail.field_meta_title} />}
           {Mediadetail.field_meta_description && (
             <meta name="twitter:description" content={Mediadetail.field_meta_description} />
           )}
             {/* ✅ Structured Data (JSON-LD) */}
            {parsedSchema && (
              <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                  __html: JSON.stringify(parsedSchema),
                }}
              />
            )}

        </head>
       </Fragment>
    <main className="main">
          {Mediadetail.field_seo_h1 && <h1 style={{ color: "white", opacity: 0,position: "absolute" }}>{Mediadetail.field_seo_h1} </h1>}
        {/* Hero Section */}
        <section id="hero" className="hero section media-hero dark-background media-banner">
            {/* <img src={Mediadbimg?.thumbnail?.[0]?.url} alt={Mediadbimg?.thumbnail?.[0]?.url} className="hero-bg" /> */}
          <img src={Mediadbimg?.thumbnail?.[0]?.url} alt="Destop Banner Image" className="hero-bg d-xl-block d-lg-block d-md-block d-sm-none w-100" loading="lazy" decoding="async" />
          <img src={MediaImgmob1?.thumbnail?.[0]?.url} alt="Mobile Banner Image" className="hero-bg d-xl-none d-lg-none d-md-none d-sm-block w-100" loading="lazy" decoding="async" />

            <div className="container">
                <div className="row gy-4  justify-content-between">

                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 d-flex flex-column text-md-start text-sm-center justify-content-center" data-aos="fade-in">
                        <label data-aos="slide-right" className="media-title-banner banner-h1"> {Mediadbannerdtl?.field_description?.[0]?.value}
                        </label>
                    </div>

                </div>
            </div>


        </section>
        <section className='p-0'>
          <div className="container py-2">
            <nav aria-label="breadcrumb animated slideInDown ">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a className="text-dark" href="/">Home</a></li>
                    <li className="breadcrumb-item"><a className="text-dark" href="/resources">Resources</a></li>
                    <li className="breadcrumb-item"><a className="text-dark text-capitalize"  href={`${pathname}`}>{Mediadetail.field_category_tag}</a></li>
                </ol>
            </nav>
        </div>
        </section>

        {/* /Hero Section */}
        {/* About career Section */}
        <section   className="about section pt-lg-5 pt-md-5 pt-0">

            <div className="container" data-aos="fade-up" data-aos-delay="100">
                <div className="row gx-2 align-items-xl-start gy-md-5 ">

                    <div className="col-xl-12 col-sm-12 content mt-0 mt-lg-4">
                        {/*<h3>About Us</h3>*/}
                        <p className='dateFormat mb-2 mb-lg-0'>{formatDate(Mediadetail.created)}</p>
                        <label className="section-title label-title pb-2">
                            {Mediadetail.field_media_title}
                        </label>
                        <img src={`${PathUrl}${Mediadetail.field_media_detail_url}`} alt={Mediadetail.field_alt_tag}  className="img-fluid mb-2 imgdetailh" width="100%" />
                        {/* <h6 className="fw-bold">
                             {Mediadetail.field_media_sub_title}
                        </h6>
                        <p dangerouslySetInnerHTML={{ __html:Mediadetail.field_media_description }} />
                        <blockquote className="blockquote" dangerouslySetInnerHTML={{ __html:Mediadetail.field_media_block_detail }} /> */}
                         
                    </div>

                    <div className="col-xl-12 col-sm-12 mediadetail mt-lg-4 mt-0">
                        <div className="row gy-4 icon-boxes">
                            <div className="col-lg-12 col-sm-12 mt-0">
                             
                            
                                <p className='mt-3' dangerouslySetInnerHTML={{ __html:Mediadetail.field_content }} />
                            </div>
                            {/* <div className="col-lg-6 col-sm-12">
                                <img src={`${PathUrl}${Mediadetail.field_media_detail_url}`} className="img-fluid"  width="100%"/>
                            </div> */}

                            {/* <div className="col-sm-12">
                                <p dangerouslySetInnerHTML={{ __html:Mediadetail.field_media_other_detail }} />
                            </div> */}
                            </div>
                        </div>

                </div>


                 

            <div className="social-share d-flex gap-3 mt-2">
              Share this article:
              <a href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`} target="_blank" rel="noopener noreferrer" className='facebookIcon'>
                <i className="bi bi-facebook"></i>
              </a>
              <a href="https://www.instagram.com/gro_digital_platforms/" target="_blank" rel="noopener noreferrer" className='instagramIcon'>
                <i className="bi bi-instagram"></i>
              </a>
              <a href={`https://twitter.com/intent/tweet?url=${currentUrl}&text=${Mediadetail.field_media_title}`} target="_blank" className='twitterIcon'>
              <i className="bi bi-twitter-x"></i></a>
              <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${currentUrl}`} target="_blank" rel="noopener noreferrer">
                <i className="bi bi-linkedin"></i>
              </a>
              
              
            </div>

            </div>

        </section>{/* /About Section */}

    </main>
   </>
);
};

export default MediaDetail;